import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";
import { NAV } from "../../data/catalog";

export const MobileMenu = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="left" data-lenis-prevent className="flex w-[88vw] max-w-md flex-col border-line bg-ivory p-8" data-testid="mobile-menu">
      <SheetTitle className="font-mono text-[11px] font-normal uppercase tracking-[0.28em] text-graphite">Menu</SheetTitle>
      <nav className="mt-8 flex flex-col gap-1">
        {NAV.map((n, i) => (
          <Link key={n.to} to={n.to} onClick={() => onOpenChange(false)} data-testid={`mobile-nav-${i}`}
            className="flex items-baseline gap-4 border-b border-line py-3 font-display text-3xl text-ink transition-[padding] duration-300 hover:pl-2">
            <span className="font-mono text-[11px] text-graphite">0{i + 1}</span>{n.label}
          </Link>
        ))}
      </nav>
      <div className="mt-auto space-y-2 pt-8 text-sm text-graphite">
        <Link to="/track-order" onClick={() => onOpenChange(false)} className="block underline-offset-4 hover:underline" data-testid="mobile-track-order">Track an order</Link>
        <Link to="/account" onClick={() => onOpenChange(false)} className="block underline-offset-4 hover:underline" data-testid="mobile-account">Account</Link>
        <p>Email support: <a href="mailto:support@shopmarkhor.com" className="text-ink underline-offset-4 hover:underline" data-testid="mobile-support-email">support@shopmarkhor.com</a></p>
      </div>
    </SheetContent>
  </Sheet>
);
